export default __webpack_public_path__ + "static/media/file_00001 (6).cbef7d86.pdf";